export default {
  videoContainer: (margin: number) => ({
    maxHeight: '1080px',
    width: ['100vw', '100vw', '100vw', '100vw', margin === 0 ? '100%' : '100vw'],
    height: ['calc(100vw * 1080 / 1920)', 'calc(100vw * 1080 / 1920)', 'calc(100vw * 1080 / 1920)', 'calc(100vw * 1080 / 1920)', 'calc(1530px * 1080 / 1920)'],
    position: 'relative',
    margin: ['48px -16px', '48px -16px', '64px -24px', '64px -24px', `0 ${margin}px 116px`]
  })
};